// extracted by mini-css-extract-plugin
export default {"page":"NewPage_page__cLu6l","mainTitle":"NewPage_mainTitle__aUWGJ","paragraph":"NewPage_paragraph__F-C-h","listTitle":"NewPage_listTitle__FfWOc","list":"NewPage_list__L5HSh"};